const defaultCatalogoCopys = {
  catalogo_integral:
    "Você paga o <b>valor total</b> da parcela durante o contrato do seu consórcio e aproveita as vantagens da menor taxa do mercado.",
  catalogo_pagametade:
    "Você paga <b>apenas 50% do valor da parcela até contemplar.</b> Depois, o valor que foi reduzido será diluído e somado nas parcelas restantes.",
  catalogo_reduzida:
    "Você tem a parcela <b>reduzida em 30% até contemplar.</b> Depois, a diferença será diluída nas parcelas restantes.",
};

export { defaultCatalogoCopys };
